(() => {
  document.addEventListener('DOMContentLoaded', function() {
    const atcButtons = document.querySelectorAll('.collections-carousel__product .add-to-cart');
    const collectionsCarouselProducts = document.querySelectorAll('.collections-carousel__product');

    // Add mutation observer to listen for changes in the collections carousel products
    collectionsCarouselProducts.forEach((product) => {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          console.log(mutation);

          if (mutation.type === 'childList') {
            const atcButton = mutation.target.querySelector('.rebuy-bundle__actions-buttons .rebuy-button');
            const atcButtonSpan = mutation.target.querySelector('.rebuy-bundle__actions-buttons .rebuy-button span');
            const atcPrice = product.dataset.price;

            if (atcButton) {
              atcButton.classList.remove('rebuy-button');
              atcButton.classList.add('add-to-cart', 'btn', 'btn--secondary');

              if (atcPrice && atcButtonSpan) {
                atcButtonSpan.textContent = `Add to Cart - ${atcPrice}`;
              }

              atcButton.addEventListener('click', function() {
                updateButtonText(atcButton, 'adding...', `Add to Cart - ${atcPrice}`);

                setTimeout(() => {
                  updateButtonText(atcButton, 'added!', `Add to Cart - ${atcPrice}`);
                }, 1000);
              });
            }
          }
        });
      });

      observer.observe(product, {
        childList: true,
      });
    });

    if (atcButtons.length) {
      atcButtons.forEach((button) => {
        button.addEventListener('click', function() {
          if (!button.dataset.id)
            return;

          const formData = {
            'items': [{
              'id': button.dataset.id,
              'quantity': 1
            }]
          };

          const fetchOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          };

          const originalText = button.textContent;

          button.textContent = 'adding...';

          fetch('/cart/add.js', fetchOptions)
              .then(response => response.json())
              .then(data => {
                if (data.status) {
                  updateButtonText('error!');

                  return;
                }

                updateButtonText(button, 'added!', originalText);
              })
              .catch((error) => {
                updateButtonText(button, 'error!', originalText)

                console.error('Error adding to cart: ', error);
              });
        });
      });
    }

    setTimeout(() => {
      let clientPortalSection = document.querySelector('form-embed#app-embed');

      if (!clientPortalSection) {
        setTimeout(() => {
          console.log('Retrying to find client portal section');

          clientPortalSection = document.querySelector('form-embed#app-embed');

          if (clientPortalSection) {
            removeOverflowHiddenOnClientPortal(clientPortalSection);
          }
        }, 3000);
      }

      else {
        removeOverflowHiddenOnClientPortal(clientPortalSection);
      }
    }, 3000);

    function updateButtonText(button, tempText, originalText) {
      button.textContent = tempText;

      setTimeout(() => {
        button.textContent = originalText;
      } , 2000);

      return;
    }
  });

  function removeOverflowHiddenOnClientPortal(clientPortalSection) {
    const targetShadowRootElement = clientPortalSection.shadowRoot.querySelector('._formContainer_stahb_30');

    console.log(clientPortalSection);

    const formTitle = document.createElement('h2');
    formTitle.id = 'client-portal';
    formTitle.classList.add('form-title');
    formTitle.textContent = 'Register Here';
    formTitle.style.textAlign = 'center';
    formTitle.style.marginBottom = '50px';
    formTitle.style.color = '#FE5442';
    clientPortalSection.parentElement.prepend(formTitle);

    targetShadowRootElement.style.overflow = 'visible';
  }
})();


